import React, { useState, useEffect } from 'react';
import { Row, Col, Dropdown, Button, ButtonGroup, Form, Modal } from 'react-bootstrap';
import { MdCalendarMonth } from "react-icons/md";
import './month-report.css';
import WorkReportLayout from '../../components/EmpWorkReportLayout.jsx';
import { IoEye } from "react-icons/io5";
import axios from 'axios';
import moment from 'moment';

export default function MonthReport() {
  const [reports, setReports] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const filteredReports = reports.filter(report => {
    return (
      report.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      report.username.toLowerCase().includes(searchQuery.toLowerCase()) ||
      report.reportingDate.includes(searchQuery)
    );
  });

  const totalPages = Math.ceil(filteredReports.length / entriesPerPage);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const pageRange = () => [...Array(totalPages).keys()].map((i) => i + 1);

  const [showModal, setShowModal] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);

  useEffect(() => {
    const fetchReports = async () => {
      try {
        const response = await axios.get('https://backend.ems.hiradentallab.com/api/reports/this-month');
        setReports(response.data.reports);
      } catch (error) {
        console.error("Error fetching reports:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchReports();
  }, []);

  const handleSearchChange = async (event) => {
    const query = event.target.value;
    setSearchQuery(query);

    try {
      const response = await axios.post('https://backend.ems.hiradentallab.com/api/reports/months/search', { query });
      setReports(response.data.reports);
    } catch (error) {
      console.error("Error fetching search results:", error);
    }
  };

  const handleEntriesChange = (numEntries) => setEntriesPerPage(numEntries);

  const handleOpenModal = (report) => {
    setSelectedReport(report);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedReport(null);
  };

  const formatDate = (date) => moment(date).format('MM/DD/YYYY');

  return (
    <div className='container-fluid'>
    <WorkReportLayout>
      <div>
        <h1 className="month-report-header">
          <MdCalendarMonth className="month-report-icon" />
          Current Month Work Report
        </h1>
        <hr />
        <div className="month-report-content">

        {/* Row for Dropdown and Search */}
        <Row className="mb-3 align-items-center justify-content-between">
          <Col xs="auto">
            <Dropdown as={ButtonGroup}>
              <Button variant="primary">Show Entries</Button>
              <Dropdown.Toggle split variant="primary" id="dropdown-split-basic" />
              <Dropdown.Menu>
                <Dropdown.Item onClick={() => handleEntriesChange(10)}>10</Dropdown.Item>
                <Dropdown.Item onClick={() => handleEntriesChange(25)}>25</Dropdown.Item>
                <Dropdown.Item onClick={() => handleEntriesChange(50)}>50</Dropdown.Item>
                <Dropdown.Item onClick={() => handleEntriesChange(100)}>100</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
          <Col xs="auto">
            <Form className="d-flex" onSubmit={(e) => e.preventDefault()}>
              <Form.Control
                type="search"
                placeholder="Search"
                aria-label="Search"
                className="search-input"
                value={searchQuery}
                onChange={handleSearchChange}
              />
            </Form>
          </Col>
        </Row>

        <div className="table-responsive">
          <table className='table table-striped'>
            <thead className='table-header'>
              <tr className="month-report-table-header">
                <th>SR</th>
                <th>Name</th>
                <th>UserName</th>
                <th>Reporting Date</th>
                <th>Reporting Time</th>
                <th>Updated</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr><td colSpan="7">Loading...</td></tr>
              ) : (
                filteredReports.slice((currentPage - 1) * entriesPerPage, currentPage * entriesPerPage).map((report, index) => (
                  <tr className="table-row" key={report.reportId}>
                    <td>{index + 1}</td>
                    <td>{report.name}</td>
                    <td>{report.username}</td>
                    <td>{moment(report.reportingDate).format('MM/DD/YYYY')}</td>
                    <td>{moment(report.reportingTime, 'HH:mm').format('h:mm A')}</td>
                    <td>{moment(report.updatedAt).format('MM/DD/YYYY')}</td>
                    <td>
                      <Button className='btn btn-primary' onClick={() => handleOpenModal(report)} size='sm'>
                        <IoEye />
                      </Button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
            <tfoot className='table-footer'>
              <tr className='month-report-table-footer'>
                <td>Total</td>
                <td>{filteredReports.length}</td>
                <td colSpan="5"></td>
              </tr>
            </tfoot>
          </table>

          <div className="pagination-row">
            <div className="entries-info">
              Showing {(currentPage - 1) * entriesPerPage + 1} to{" "}
              {Math.min(currentPage * entriesPerPage, filteredReports.length)} of{" "}
              {filteredReports.length} entries
            </div>
            <nav>
              <ul className="pagination no-gap">
                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                  <a href="/#" className="page-link" onClick={(e) => {
                    e.preventDefault();
                    handlePageChange(currentPage - 1);
                  }}>
                    Previous
                  </a>
                </li>
                {pageRange().map((pageNumber) => (
                  <li key={pageNumber} className={`page-item ${currentPage === pageNumber ? "active" : ""}`}>
                    <a href="/#" className="page-link" onClick={(e) => {
                      e.preventDefault();
                      handlePageChange(pageNumber);
                    }}>
                      {pageNumber}
                    </a>
                  </li>
                ))}
                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                  <a href="/#" className="page-link" onClick={(e) => {
                    e.preventDefault();
                    handlePageChange(currentPage + 1);
                  }}>
                    Next
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
</div>
        <Modal show={showModal} onHide={handleCloseModal} centered>
          <Modal.Header closeButton style={{ background: "#004aad", color: "#ffffff" }}>
            <Modal.Title>Report Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedReport && (
              <div>
                <h6>Start Date: <span style={{ color: "#007bff" }}>{formatDate(selectedReport.startDate)}</span></h6>
                <h6>Reporting Time: <span style={{ color: "#007bff" }}>{selectedReport.reportingTime}</span></h6>
                <div dangerouslySetInnerHTML={{ __html: selectedReport.report }} />
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>Close</Button>
          </Modal.Footer>
        </Modal>
      </div>
    </WorkReportLayout>
    </div>
  );
}
